import {getOptionByAlias} from 'features/wizardMs/libs/getOptionByAlias';
import {QuoteItemType} from 'constants/flow/flowTypesCart';
import {PRODUCT_TYPES} from 'constants/product';

const LENS_TYPES: {[key: string]: string} = {
    'Single-Vision': 'Single Vision',
    Reading: 'Near Vision',
    Progressive: 'Progressive',
    Bifocal: 'Bifocal',
    Frame: 'Non-Prescription',
};

/**
 * Get information on product lens types for a product quoteItem
 * @param {QuoteItemType} product - quoteItem product
 * @returns {string} Lens type
 */
export const getLensType = (product: QuoteItemType): string => {
    if (product.type === PRODUCT_TYPES.CONTACT_LENSES) return 'N/A';

    if ('options' in product)
        return LENS_TYPES[getOptionByAlias(product, 'usage')?.sku || ''] || 'N/A';

    return 'N/A';
};
